module.exports = __webpack_public_path__ + "img/stick_hebergements_hotel_2.c04dc38a.svg";